import { render, staticRenderFns } from "./ForgotForm.vue?vue&type=template&id=eaeea768&scoped=true&"
import script from "./ForgotForm.vue?vue&type=script&lang=js&"
export * from "./ForgotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaeea768",
  null
  
)

export default component.exports